<template src="./edit-quiz-single-question.html"></template>
<script>
import VueTagsInput from "@johmun/vue-tags-input";
import ClickOutside from "vue-click-outside";
import quizService from "../../../services/quiz-service";
import tagService from "../../../services/tag-service";
import storageService from "../../../services/storage-service";
import courseSubTopicService from "../../../services/course-sub-topic-service";
import courseTopicService from "../../../services/course-topic-service";
import quizConfigurationService from "../../../services/quiz-configuration-service";
import draggable from "vuedraggable";
import _ from "lodash";

function Stack() {
  this.stac = new Array();
  this.pop = function () {
    return this.stac.pop();
  };
  this.push = function (item) {
    this.stac.push(item);
  };
}
var chevronListBox;
var windowType = 1;
var stack = new Stack();
export default {
  name: "app-edit-quiz-single-question",
  components: {
    VueTagsInput,
    draggable,
  },
  directives: {
    ClickOutside,
  },
  data: function () {
    return {
      alphabets: ["A", "B", "C", "D", "E", "F", "G", "H", "I"],
      chevronListBox,
      windowType,
      stack,
      tag: "",
      selectedTags: [],
      natureTags: this.parentNatureTags || [],
      selectedNature: null,
      difficulty_level: "",
      ai_config: {
        content: 'check Content of answer and give marks out of 100 in content_marks field',
        understanding: 'check Understanding of answer and give marks out of 100 in understanding_marks field',
        writing_skill: 'check Writing Skill of answer and give marks out of 100 in writing_skills_marks field',
        evidence: 'check Evidence of answer and give marks out of 100 in evidence_marks field',
        organization: 'check Organization of answer and give marks out of 100 in organization_marks field',
      },
      errors: [],
      ommissions: [],
      DAQ: false,
      
      // Subtopics
      subtopics: this.parentSubtopics || [],
      showSubtopicDropdown: false,
      subtopicSearch: "",
      loadingSubtopics: false,
      
      
      // Configurations
      configurations: this.parentConfigurations || [],
      showConfigDropdown: false,
      configSearch: "",
      loadingConfig: false,
      apiLoadedConfig: false,



      // Topics
      availableTopics: this.parentTopics || [],
      topicSearch: "",
      showTopicDropdown: false,
      loadingTopics: false,
      
      // IDs to resolve after API fetch
      topicIdsToResolve: [],
      subtopicIdsToResolve: [],

      // Learning Outcomes
      availableLearningOutcomes: [],
      showLearningOutcomeDropdown: false,
      learningOutcomeSearch: "",
      loadingLearningOutcomes: false,
    };
  },
  watch: {
    question: {
      handler(question) {
        // Don't call updateLocalStorage() here: updateLocalStorage mutates
        // the same question object on the parent, which retriggers this
        // deep watcher and can cause an infinite loop. updateLocalStorage
        // is invoked explicitly from methods that perform mutations.
        this.validateQuestion();
      },
      deep: true,
    },
    index(val, prevVal) {
      this.selectedTags = [];
      if (this.question.related_video_id) {
        if (this.videos && this.videos.length) {
          this.videos.forEach((video) => {
            if (video.id == this.question.related_video_id) {
              this.question.related_video = video;
            }
          });
        }
      }
      if (this.question.tags && this.question.tags.length) {
        this.question.tags.forEach((elm) => {
          if (elm.tag_type === "general") {
            this.selectedTags.push({ id: elm._id, text: elm.tag_name });
          } else if (elm.tag_type === "nature") {
            this.selectedNature = elm;
            // Sync difficulty level based on nature tag
            if (elm.tag_name === 'Knowledge') this.difficulty_level = 'Easy';
            else if (elm.tag_name === 'Understanding') this.difficulty_level = 'Medium';
            else if (elm.tag_name === 'Application') this.difficulty_level = 'Hard';
          }
        });
      }
      this.validateQuestion();
    },
    'question.total_marks': {
    handler(newMarks) {
      this.updatePromptMarks(newMarks);
    }
  },
    quiz: {
      handler(val) {
        if (val && (val.created_by || val.instructor_id)) {
           // We might not need to fetch here if parent handles it, but keep for safety/reactivity if parent props update
           // Actually, clearer to rely on parent props.
        }
      },
      deep: true
    },
    parentConfigurations: {
      handler(val) {
        if (val && val.length) {
          this.configurations = val;
          // Trigger resolution/defaults logic if needed
           this.resolveConfigurationDefaults();
        }
      },
      immediate: true
    },
    parentTopics: {
      handler(val) {
        if (val && val.length) {
          this.availableTopics = val;
          this.resolveTopicDefaults(); 
        }
      },
      immediate: true
    },
    parentSubtopics: {
        handler(val) {
            if (val && val.length) {
                this.subtopics = val;
                this.resolveSubtopicDefaults();
            }
        },
        immediate: true
    },
    parentNatureTags: {
      handler(val) {
        if (val && val.length) {
          this.natureTags = val;
        }
      },
      immediate: true
    }
  },
  props: {
    index: {
      type: String,
    },
    question: {
      type: Object,
    },
    videos: {
      type: Array,
    },
    sections: {
      type: Array,
    },
    paragraphs: {
      type: Array,
    },
    tags: {
      type: Array,
    },
    key: {
      type: Number,
    },
    quizType: {
      type: String,
    },
    ai: {
      type: Boolean,
    },
    quiz: {
      type: Object,
    },
    parentConfigurations: {
      type: Array,
      default: () => []
    },
    parentTopics: {
      type: Array,
       default: () => []
    },
    parentSubtopics: {
      type: Array,
       default: () => []
    },
    parentNatureTags: {
      type: Array,
      default: () => null
    },
    isCSVUpload: {
      type: Boolean,
      default: false
    },
    isInterchangeableModule: {
      type: Boolean,
      default: false,
    },
    interchangeableScopes: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    filteredItems() {
      return this.tags.filter((i) => {
        return i.text.toLowerCase().indexOf(this.tag.toLowerCase()) !== -1;
      });
    },
    selectedTopics() {
        return this.question.topics || [];
    },
    selectedConfigurations() {
        return this.question.configurations || [];
    },
    selectedSubtopics() {
        return this.question.subtopics || [];
    },
    groupedConfigurations() {
      return this.groupTaxonomyByName(this.selectedConfigurations);
    },
    groupedTopics() {
      return this.groupTaxonomyByName(this.selectedTopics);
    },
    groupedSubtopics() {
      return this.groupTaxonomyByName(this.selectedSubtopics);
    },
    /** FSc Intermediate niche/tag only — CSS/MDCAT must not show board chrome. */
    showFscBoardUi() {
      const FSC_TAG_ID = 19;
      const quiz = this.quiz || {};
      const routeTag = this.$route && this.$route.query ? this.$route.query.tag_id : null;
      const candidates = [
        quiz.tag_id,
        quiz.course_tag_id,
        quiz.course && quiz.course.tag_id,
        routeTag,
      ];
      for (let i = 0; i < candidates.length; i += 1) {
        const n = Number(candidates[i]);
        if (Number.isFinite(n) && n > 0) return n === FSC_TAG_ID;
      }
      const configs = this.selectedConfigurations || [];
      const niches = [];
      configs.forEach((c) => {
        if (!c || c.niche_id == null) return;
        if (Array.isArray(c.niche_id)) niches.push(...c.niche_id);
        else niches.push(c.niche_id);
      });
      if (niches.length) return niches.map(Number).includes(FSC_TAG_ID);
      return false;
    },
    filteredLearningOutcomes() {
        if (!this.learningOutcomeSearch) {
            return this.availableLearningOutcomes;
        }
        const search = this.learningOutcomeSearch.toLowerCase();
        return this.availableLearningOutcomes.filter(lo => 
            lo.toLowerCase().includes(search)
        );
    },
  },
  created() {
      // For CSV uploads, the server passes the raw pipe-delimited string
      // in question.learning_outcomes. We must convert it to an array
      // BEFORE the template renders, otherwise v-for iterates over individual characters.
      if (this.isCSVUpload && this.question.learning_outcomes && typeof this.question.learning_outcomes === 'string') {
          // Save the raw string for later matching in resolveSubtopicDefaults -> step 5
          this.$set(this.question, '_csv_learning_outcomes', this.question.learning_outcomes);
          this.$set(this.question, 'learning_outcomes', []);
      }
  },
  mounted() {
      const hasRealHTML = (str) => {
        if (typeof str !== 'string') return false;
        // Check for HTML tags (more than just '<')
        return /<[a-z][^>]*>/i.test(str);
      };

      // Your condition:
      if (this.question.question.startsWith("<") && !hasRealHTML(this.question.question)) {
        this.question.question = this.question.question_and_equation;
      }
    
    if(!this.question.ai_config) {
      this.question.ai_config = {
        content: true,
        understanding: true,
        writing_skill: true,
        evidence: true,
        organization: true,
      };
    }

    // Track which fields the user has manually edited so that
    // resolve*Defaults() does NOT re-merge quiz-level defaults on re-mount.
    if (!this.question._userEditedFields) {
      this.$set(this.question, '_userEditedFields', {
        configurations: false,
        topics: false,
        subtopics: false,
      });
    }

    const totalMarks = this.question.total_marks || 100; // Add this line
  
  if(!this.question.ai_prompt_checking) {
    this.question.ai_prompt_checking = `check answer of question and give marks out of ${totalMarks} in marks_obtained field`;
  }
  if(!this.question.ai_evaluation_prompt) {
    this.question.ai_evaluation_prompt = 'give evaluation result or any suggestions for improvement in evaluation_result field in text';
  }
  if(!this.question.ai_content_prompt) {
    this.question.ai_content_prompt = `check Content of answer and give marks out of ${totalMarks} in content_marks field`;
  }
  if(!this.question.ai_understanding_prompt) {
    this.question.ai_understanding_prompt = `check Understanding of answer and give marks out of ${totalMarks} in understanding_marks field`;
  }
  if(!this.question.ai_writting_skill_prompt) {
    this.question.ai_writting_skill_prompt = `check Writing Skill of answer and give marks out of ${totalMarks} in writing_skills_marks field`;
  }
  if(!this.question.ai_evidence_prompt) {
    this.question.ai_evidence_prompt = `check Evidence of answer and give marks out of ${totalMarks} in evidence_marks field`;
  }
  if(!this.question.ai_organization_prompt) {
    this.question.ai_organization_prompt = `check Organization of answer and give marks out of ${totalMarks} in organization_marks field`;
  }
    if(!this.question.ai_evaluation_prompt_chain || this.question.ai_evaluation_prompt_chain.length === 0) {
      this.question.ai_evaluation_prompt_chain = [{value: this.question.ai_evaluation_prompt}];
    }
    this.selectedTags = [];
    if (this.question.related_video_id) {
      if (this.videos && this.videos.length) {
        this.videos.forEach((video) => {
          if (video.id == this.question.related_video_id) {
            this.question.related_video = video;
          }
        });
      }
    }
    if (this.question.tags && this.question.tags.length) {
      this.question.tags.forEach((elm) => {
        if (elm.tag_type === "general") {
          if(this.ai !== 'true') {
            this.selectedTags.push({ id: elm._id, text: elm.tag_name });
          }
        } else if (elm.tag_type === "nature") {
          this.selectedNature = elm;
        } else {
          this.difficulty_level = elm.tag_name;
        }
      });
    }
    if ((this.ai === true || this.ai === 'true') && this.question.ai_topic) {
      console.log(this.question)
      this.selectedTags.push({ id: this.question.ai_topic._id, text: this.question.ai_topic.name });
    }
    if (this.question.difficulty_level) {
      this.difficulty_level = this.question.difficulty_level;
      this.onDifficultyLevelChange(this.question.difficulty_level);
    }
    
    // Normalize CSV aliases/strings before any topic resolution logic.
    if (this.isCSVUpload) {
      this.normalizeCsvMappingFields();
      this.resolveConfigurationDefaults();
    }

    // Initialize topics and subtopics from course_topics if available
    if (this.question.course_topics && Array.isArray(this.question.course_topics) && this.question.course_topics.length > 0) {
      // Extract topics (type: "topic") — only if they have a name to display
      const extractedTopics = this.question.course_topics
        .filter(ct => ct.type === 'topic' && ct.name)
        .map(ct => ({
          _id: ct._id,
          name: ct.name,
          configuration_id: ct.configuration_id
        }));
      
      // Extract subtopics (type: "sub-topic") — only if they have a name to display
      const extractedSubtopics = this.question.course_topics
        .filter(ct => ct.type === 'sub-topic' && ct.name)
        .map(ct => ({
          _id: ct._id,
          name: ct.name,
          topic_id: ct.topic_id
        }));
      
      // Only use extracted topics if we found any with names
      if (extractedTopics.length > 0) {
        if (!this.question.topics || this.question.topics.length === 0 || typeof this.question.topics[0] === 'string') {
          this.question.topics = extractedTopics;
        }
      } else {
        // course_topics entries have no name — store raw IDs for resolution from availableTopics later
        if (this.question.topics && Array.isArray(this.question.topics) && this.question.topics.length > 0 && typeof this.question.topics[0] === 'string') {
          this.topicIdsToResolve = [...this.question.topics];
          this.$set(this.question, 'topics', []);
        }
      }
      
      // Same for subtopics
      if (extractedSubtopics.length > 0) {
        if (!this.question.subtopics || this.question.subtopics.length === 0 || typeof this.question.subtopics[0] === 'string') {
          this.question.subtopics = extractedSubtopics;
        }
      } else {
        // course_topics entries have no name — store raw IDs for resolution from subtopics pool later
        if (this.question.subtopics && Array.isArray(this.question.subtopics) && this.question.subtopics.length > 0 && typeof this.question.subtopics[0] === 'string') {
          this.subtopicIdsToResolve = [...this.question.subtopics];
          this.$set(this.question, 'subtopics', []);
        }
      }
    } else {
      // Fallback: course_topics is empty, try to resolve IDs using fetched availableTopics and subtopics
      
      // Handle topics - if they're IDs, try to map them using availableTopics
      if (this.question.topics && Array.isArray(this.question.topics) && this.question.topics.length > 0) {
        if (typeof this.question.topics[0] === 'string') {
          // Topics are IDs - we'll resolve them after fetchTopics completes
          // Store the IDs temporarily, they'll be resolved in a watcher or after fetch
          this.topicIdsToResolve = [...this.question.topics];
          this.$set(this.question, 'topics', []);
        }
        // else: topics already contain objects, keep them as-is
      } else {
        // Initialize as empty array if not present
        if (!this.question.topics) {
          this.$set(this.question, 'topics', []);
        }
      }
      
      // Handle subtopics - if they're IDs, try to map them using subtopics array
      if (this.question.subtopics && Array.isArray(this.question.subtopics) && this.question.subtopics.length > 0) {
        if (typeof this.question.subtopics[0] === 'string') {
          // Subtopics are IDs - we'll resolve them after fetchSubTopics completes
          // Store the IDs temporarily, they'll be resolved after fetch
          this.subtopicIdsToResolve = [...this.question.subtopics];
          this.$set(this.question, 'subtopics', []);
        }
        // else: subtopics already contain objects, keep them as-is
      } else {
        // Initialize as empty array if not present
        if (!this.question.subtopics) {
          this.$set(this.question, 'subtopics', []);
        }
      }
    }
    
    this.validateQuestion();
    
    // Initialize selectedConfigurations from quiz object
    // We rely on watchers to call these resolution methods now.
    // However, if props are already here (immediate watchers ran), we are good.
    // If props are empty/loading, watchers will fire later.
    
    // Fallback: If for some reason props are empty but we have local requirements, we might need to fetch.
    // But initially, let's assume parent handles it.
    
    // We still fetch nature tags as they are static/global usually
    // this.fetchNatureTags(); // Optimization: Use parentNatureTags prop instead
    // Only fetch locally if the parent prop is NOT provided (null)
    // If it is provided (even as empty array), we wait for watcher update.
    if (this.parentNatureTags === null) {
       this.fetchNatureTags();
    }
    
    // Fetch learning outcomes if subtopics are already selected (edit mode)
    if (this.question.subtopics && this.question.subtopics.length > 0) {
      this.fetchLearningOutcomes();
    }
  },
  methods: {
    groupTaxonomyByName(items = []) {
      const map = new Map();
      (items || []).forEach((item) => {
        if (!item) return;
        const name = String(item.name || "Untitled").trim() || "Untitled";
        const key = name.toLowerCase();
        if (!map.has(key)) map.set(key, { key, name, items: [] });
        map.get(key).items.push(item);
      });
      return [...map.values()];
    },
    getScopeMeta(item) {
      if (!item) return { full: "", short: "", board: "", program: "", classYear: "" };
      if (item.scope_label) {
        const parts = String(item.scope_label).split("·").map((p) => p.trim()).filter(Boolean);
        const cleaned = parts.map((p) => p.replace(/\s*Board\s*$/i, "").replace(/^Class\s+/i, "").trim());
        const board = cleaned[0] || "";
        const program = cleaned[1] || "";
        const classYear = cleaned[2] || "";
        const short = cleaned.join(" · ");
        return { full: item.scope_label, short: short || item.scope_label, board, program, classYear };
      }
      const boardName = item.board_name || item.board || "";
      const programName = item.program_name || item.program || "";
      const boardId = Array.isArray(item.board_ids) && item.board_ids.length ? Number(item.board_ids[0]) : null;
      const programId = Array.isArray(item.program_ids) && item.program_ids.length ? Number(item.program_ids[0]) : null;
      const classYear = Array.isArray(item.classes) && item.classes.length ? String(item.classes[0]) : "";
      const board = (boardName || (boardId != null ? `Board ${boardId}` : "")).replace(/\s*Board\s*$/i, "").trim();
      const program = programName || (programId != null ? `Program ${programId}` : "");
      const short = [board, program, classYear].filter(Boolean).join(" · ");
      return { full: short, short, board, program, classYear };
    },
    getTaxonomyScopeLabel(item) {
      return this.getScopeMeta(item).full;
    },
    getTaxonomyScopeShort(item) {
      return this.getScopeMeta(item).short;
    },
    getTaxonomyBoardName(item) {
      const meta = this.getScopeMeta(item);
      if (meta.board) return meta.board;
      if (meta.short) return String(meta.short).split("·")[0].trim();
      // CSS / MDCAT / unscoped configs have no board — do not show "All boards"
      return "";
    },
    getTaxonomyScopeSecondary(item) {
      const meta = this.getScopeMeta(item);
      const bits = [meta.program, meta.classYear].filter(Boolean);
      if (bits.length) return bits.join(" · ");
      if (!meta.short) return "";
      const parts = String(meta.short).split("·").map((p) => p.trim()).filter(Boolean);
      return parts.length > 1 ? parts.slice(1).join(" · ") : "";
    },
    removeTaxonomyScope(field, item) {
      if (!item || !item._id || !Array.isArray(this.question[field])) return;
      this.$set(
        this.question,
        field,
        this.question[field].filter((entry) => String(entry && (entry._id || entry)) !== String(item._id)),
      );
      if (this.question._userEditedFields) this.question._userEditedFields[field] = true;
      this.$parent.updateLocalStorage();
      if (field === "configurations") {
        const remaining = this.question.configurations || [];
        if (remaining.length) this.fetchTopics("", remaining.map((c) => c._id));
        else {
          this.availableTopics = [];
          this.$set(this.question, "topics", []);
          this.$set(this.question, "subtopics", []);
        }
      } else if (field === "topics") {
        if ((this.question.topics || []).length) this.fetchSubTopics();
        else {
          this.subtopics = [];
          this.$set(this.question, "subtopics", []);
        }
      } else if (field === "subtopics") {
        this.fetchLearningOutcomes();
      }
      this.$forceUpdate();
    },
    removeTaxonomyGroup(field, group) {
      if (!group || !group.items) return;
      const ids = new Set(group.items.map((item) => String(item._id)));
      const next = (this.question[field] || []).filter(
        (entry) => !ids.has(String(entry && (entry._id || entry))),
      );
      this.$set(this.question, field, next);
      if (this.question._userEditedFields) this.question._userEditedFields[field] = true;
      this.$parent.updateLocalStorage();
      if (field === "configurations") {
        if (next.length) this.fetchTopics("", next.map((c) => c._id));
        else {
          this.availableTopics = [];
          this.$set(this.question, "topics", []);
          this.$set(this.question, "subtopics", []);
        }
      } else if (field === "topics") {
        if (next.length) this.fetchSubTopics();
        else {
          this.subtopics = [];
          this.$set(this.question, "subtopics", []);
        }
      } else if (field === "subtopics") {
        this.fetchLearningOutcomes();
      }
      this.$forceUpdate();
    },
    parseCsvList(value) {
      if (Array.isArray(value)) return value;
      if (!value || typeof value !== "string") return [];
      return value
        .split("|")
        .map(v => v.trim())
        .filter(Boolean);
    },
    normalizeCsvMappingFields() {
      const configSource = this.question.configurations || this.question.configuration || this.question.config;
      const topicSource = this.question.topics || this.question.topic || this.question.csv_topic;
      const subTopicSource = this.question.subtopics || this.question.sub_topics || this.question.sub_topic || this.question.csv_sub_topics;

      if (configSource && !Array.isArray(this.question.configurations)) {
        this.$set(this.question, "configurations", this.parseCsvList(configSource));
      }
      if (topicSource && !Array.isArray(this.question.topics)) {
        this.$set(this.question, "topics", this.parseCsvList(topicSource));
      }
      if (subTopicSource && !Array.isArray(this.question.subtopics)) {
        this.$set(this.question, "subtopics", this.parseCsvList(subTopicSource));
      }
      if (!this.question.sub_topics && typeof subTopicSource === "string") {
        this.$set(this.question, "sub_topics", subTopicSource);
      }
    },
    addNewPrompt() {
      const newPrompt = '';
      this.question.ai_evaluation_prompt_chain.push({ value: newPrompt });
      this.$forceUpdate();
    },


    hasHtml(content) {
      const pattern = /<\/?[a-z][\s\S]*>/i;
      return pattern.test(content);
    },
    deletePrompt(index) {
      this.question.ai_evaluation_prompt_chain.splice(index, 1);
      this.$forceUpdate();
    },
    updatePromptConfig() {
      this.$forceUpdate();
    },
    onDifficultyLevelChange() {
      // Map difficulty to nature tag name
      let tagName = '';
      if (this.difficulty_level === 'Easy') tagName = 'Knowledge';
      else if (this.difficulty_level === 'Medium') tagName = 'Understanding';
      else if (this.difficulty_level === 'Hard') tagName = 'Application';
      
      if (tagName && this.natureTags) {
          const natureTag = this.natureTags.find(t => t.tag_name === tagName);
          if (natureTag) {
              this.onNatureChange(natureTag);
          }
      }
    },
    onChange(event) {
      this.videos.forEach((video, index) => {
        if (video.id.toString() === event.target.value) {
          this.question.related_video = video;
        }
      });
      this.$parent.updateLocalStorage();
      this.validateQuestion();
    },
    markTrueOrFalse(optionIndex) {
      optionIndex = parseInt(optionIndex, 10);
      this.question.options[optionIndex].is_correct = true;
      if (this.question.options[optionIndex].is_correct) {
        this.question.options.forEach((option, index) => {
          if (index !== optionIndex) {
            this.question.options[index].is_correct = false;
          }
        });
      }
      this.$parent.updateLocalStorage();
      this.validateQuestion();
    },
    imgPlaceholder(e) {
      e.target.src = "../img/icons/Group 1572.svg";
    },
    moveQuestionUp() {
      this.$parent.moveQuestionUp(this.index);
    },
    moveQuestionDown() {
      this.$parent.moveQuestionDown(this.index);
    },
    deleteQuestion() {
      this.$toast.warning("You are going to delete this question");
      this.$parent.deleteQuestion(this.index);
    },
    async saveNewTags(newTags) {
      try {
        this.selectedTags = newTags;
        if (this.selectedTags.length || this.difficulty_level) {
          let allTags = [];
          if (this.difficulty_level) {
            allTags.push({
              tag_name: this.difficulty_level,
              tag_type: "level",
            });
          }
          if(this.selectedTags.length > 0) {
            this.selectedTags.forEach((element) => {
              allTags.push({ tag_name: element.text, tag_type: "general" });
            });
          }
          if (this.selectedNature) {
            allTags.push({
              tag_name: this.selectedNature.tag_name,
              tag_type: "nature",
              _id: this.selectedNature._id
            });
          }
          if (allTags.length) {
            let res = await tagService.saveTags({ tags: allTags });
            if (res) {
              this.question.tags = res.data.data.tags;
              this.$parent.updateLocalStorage();
              this.validateQuestion();
            }
          } else {
            this.question.tags = allTags;
          }
        } else {
          this.question.tags = [];
          this.$parent.updateLocalStorage();
          this.validateQuestion();
        }
      } catch (error) {
        console.log("error", error);
        this.$toast.error(error.response.data.message);
      }
    },
    async fetchNatureTags() {
      try {
        const response = await tagService.getAllNatureTags();
        if (response.data.status === "success") {
          this.natureTags = response.data.data.tag;
        }
      } catch (error) {
        console.error("Error fetching nature tags:", error);
      }
    },
    onNatureChange(nature) {
      this.selectedNature = nature;
      this.saveNewTags(this.selectedTags);
    },
    async fileChooser(type, indx) {
      try {
        const userId = storageService.get("uid");
        var input = document.createElement("input");
        input.type = "file";
        input.accept = "image/*";
        input.onchange = async (e) => {
          if (parseInt(e.target.files.length) > 1) {
            this.$toast.warning("You can only upload a single image file");
          } else {
            var formData = new FormData();
            formData.append("file", e.target.files[0]);
            formData.append("userId", userId);
            try {
              let res = await quizService.uploadImage(formData);
              if (res) {
                if (type === "question") {
                  this.question.image_url = res.data.link;
                } else if (type === "solution") {
                  this.question.solution_image_url = res.data.link;
                } else {
                  this.question.options[indx].image_url = res.data.link;
                }
              }
            } catch (error) {
              console.log("error", error);
              this.$toast.error(error.response.data.message);
            }
          }
        };
        input.click();
      } catch (e) {
        this.$toast.error(e.message);
      }
    },
    assignWeightage() {
      if (this.question.weightage) {
        this.question.self_assigned_weightage = true;
      } else {
        this.question.self_assigned_weightage = false;
      }
    },
    addOption() {
      if (this.question.options.length < 8)
        this.question.options.push({ ...this.$parent.question.options[0] });
    },
    addSolution() {
      if (this.question.solution)
        this.question.solution.push({ ...this.$parent.question.solution[0] });
    },
    removeOption(index) {
      if (this.question.options.length > 2) {
        this.question.options.splice(index, 1);
      }
    },
    chevronListBoxHandler() {
      this.chevronListBox = !this.chevronListBox;
    },
    firstWindowHandler(type) {
      this.windowType = type;
    },
    equationToggle(id) {
      this.$toast.warning(
        "Warning! Switching text area will erase your written text"
      );
      if (id.includes("option")) {
        let value = id.split("-");
        if (this.question.options[value[0]].equation) {
          this.question.options[value[0]].equation = "";
        } else {
          this.question.options[value[0]].equation = " ";
        }
      } else {
        if (this.question[id]) {
          this.question[id] = "";
        } else {
          this.question[id] = " ";
        }
      }
      this.$parent.updateLocalStorage();
      this.validateQuestion();
    },
    mathCreator: function (question, id, data) {
      setTimeout(() => {
        let mathFieldSpan = document.getElementById(id);
        let MQ = MathQuill.getInterface(2);
        let mathField = MQ.MathField(mathFieldSpan, {
          spaceBehavesLikeTab: false, // configurable
          handlers: {
            edit: function () {
              if (id.includes("option")) {
                let value = id.split("-");
                question.options[value[1]].equation = mathField.latex();
              } else {
                let key = id.split("-");
                question[key[1]] = mathField.latex();
              }
            },
          },
        });
        if (mathField) {
          if (!data.match(/\\\s/g)) {
            data = data.replace(/\s+/g, "\\ ");
          }
          if (data !== "" && data !== "null") {
            mathField.latex(data);
            if (!mathField.latex()) {
              if (id.includes("option")) {
                let value = id.split("-");
                question.options[value[1]].equation = " ";
              } else {
                let key = id.split("-");
                question[key[1]] = " ";
              }
              this.validateQuestion();
            }
          }
        }
      }, 10);
    },
    validateQuestion() {
      try {
        let errors = [];
        let ommissions = [];
        const question = this.question;
        if (
          question.equation === undefined ||
          question.equation === "" ||
          question.equation === " " ||
          !question.equation.replace(`\\`, "").trim()
        ) {
          if (
            question.question === undefined ||
            question.question === "" ||
            question.question === " "
          ) {
            errors.push(`Question text can not be empty`);
          }
        }
        if (question.options && question.options.length) {
          let oneOptionIsCorrect = 0;
          question.options.forEach((option, indx) => {
            if (
              option.equation === undefined ||
              option.equation === "" ||
              option.equation === " " ||
              !option.equation.replace(`\\`, "").trim()
            ) {
              if (
                option.option === undefined ||
                option.option === "" ||
                option.option === " "
              ) {
                errors.push(`Option text can not be empty at option # ${indx}`);
              }
            }
            if (option.is_correct === true) {
              oneOptionIsCorrect += 1;
            }
            if (indx + 1 === question.options.length) {
              if (oneOptionIsCorrect === 0) {
                errors.push(`Correct option is required`);
              } else if (oneOptionIsCorrect > 1) {
                errors.push(`Only one option be marked as true`);
              }
            }
          });
        }
        if (question.tags && !question.tags.length) {
          ommissions.push(`Minimum one tag should be added`);
        }

        if (this.quizType === 'daq') {
          const level = question.question_type_level
            ? String(question.question_type_level).trim().toLowerCase()
            : '';
          if (!['long', 'short', 'numerical'].includes(level)) {
            ommissions.push('Question Type Level is required (Long, Short, or Numerical)');
          }
        }

        // Validations for Dropdowns — not required for OMR quizzes
        if (this.quizType !== 'omr') {
          if (!question.configurations || !question.configurations.length) {
            errors.push(`Minimum one configuration is required`);
          }
          if (!question.topics || !question.topics.length) {
            errors.push(`Minimum one topic is required`);
          }
          if (!question.subtopics || !question.subtopics.length) {
            errors.push(`Minimum one subtopic is required`);
          }
        }

        this.errors = errors;
        this.ommissions = ommissions;
        // this.$parent.updateLocalStorage();
      } catch (error) {
        console.error(error);
      }
    },
    updatePromptMarks(marks) {
  const totalMarks = marks || 100;
  
  if (this.question.ai_prompt_checking) {
    this.question.ai_prompt_checking = this.question.ai_prompt_checking.replace(
      /marks out of \d+/g,
      `marks out of ${totalMarks}`
    );
  }
  
  if (this.question.ai_content_prompt) {
    this.question.ai_content_prompt = this.question.ai_content_prompt.replace(
      /marks out of \d+/g,
      `marks out of ${totalMarks}`
    );
  }
  
  if (this.question.ai_understanding_prompt) {
    this.question.ai_understanding_prompt = this.question.ai_understanding_prompt.replace(
      /marks out of \d+/g,
      `marks out of ${totalMarks}`
    );
  }
  
  if (this.question.ai_writting_skill_prompt) {
    this.question.ai_writting_skill_prompt = this.question.ai_writting_skill_prompt.replace(
      /marks out of \d+/g,
      `marks out of ${totalMarks}`
    );
  }
  
  if (this.question.ai_evidence_prompt) {
    this.question.ai_evidence_prompt = this.question.ai_evidence_prompt.replace(
      /marks out of \d+/g,
      `marks out of ${totalMarks}`
    );
  }
  
  if (this.question.ai_organization_prompt) {
    this.question.ai_organization_prompt = this.question.ai_organization_prompt.replace(
      /marks out of \d+/g,
      `marks out of ${totalMarks}`
    );
  }
  
  this.$parent.updateLocalStorage();
  this.$forceUpdate();
},

    // Subtopic Methods
    // Configuration Methods
    
    resolveConfigurationDefaults() {
        // CSV: configs arrive as full objects from upload — resolve without waiting for parent pool.
        if (this.isCSVUpload && this.question.configurations && this.question.configurations.length > 0) {
            if (typeof this.question.configurations === "string") {
              this.$set(this.question, "configurations", this.parseCsvList(this.question.configurations));
            }
            this.question.configurations = this.question.configurations
              .map(c => {
                if (typeof c === "string") {
                  const token = c.trim().toLowerCase();
                  if (this.configurations && this.configurations.length) {
                    const byId = this.configurations.find(conf => String(conf._id) === String(c));
                    if (byId) return byId;
                    return this.configurations.find(conf => (conf.name || "").trim().toLowerCase() === token) || null;
                  }
                  return null;
                }
                return c;
              })
              .filter(c => c && c._id);
            if (!this.configurations) {
              this.configurations = [];
            }
            this.question.configurations.forEach((c) => {
              if (!this.configurations.some((pc) => String(pc._id) === String(c._id))) {
                this.configurations.push(c);
              }
            });
            this.validateQuestion();
            this.$parent.updateLocalStorage();
            return;
        }

        if (!this.configurations || !this.configurations.length) return;

        // 1. Resolve any string IDs in question.configurations to objects
        if (this.question.configurations && this.question.configurations.length) {
            this.question.configurations = this.question.configurations.map(conf => {
                if (typeof conf === 'string') {
                    return this.configurations.find(c => c._id === conf) || null;
                }
                return conf;
            }).filter(conf => conf !== null); 
        }
        
        // 2. Merge quiz default configurations into question.configurations
        //    SKIP for CSV uploads — CSV questions should only have their own per-question configs
        //    SKIP if user has manually edited configurations for this question
        //    SKIP if question already has its own configurations (resolved in step 1)
        if (!this.isCSVUpload
            && !(this.question._userEditedFields && this.question._userEditedFields.configurations)
            && (!this.question.configurations || this.question.configurations.length === 0)) {
            let defaultConfigIds = [];
            if (this.quiz && this.quiz.configuration_id) {
                 if (Array.isArray(this.quiz.configuration_id)) {
                    defaultConfigIds = this.quiz.configuration_id;
                } else {
                    defaultConfigIds = [this.quiz.configuration_id];
                }
                defaultConfigIds = defaultConfigIds.map(c => (c && typeof c === 'object') ? (c._id || c) : c);
            }

            if (defaultConfigIds.length > 0) {
                if (!this.question.configurations) {
                    this.$set(this.question, 'configurations', []);
                }
                const defaultConfigs = this.configurations.filter(c => defaultConfigIds.includes(c._id));
                defaultConfigs.forEach(dc => {
                    if (!this.question.configurations.some(qc => qc._id === dc._id)) {
                        this.question.configurations.push(dc);
                    }
                });
                this.$parent.updateLocalStorage();
            }
        }
    },
    
    async fetchConfigurations(search = "") {
       // If we already have configurations from props and no search, don't re-fetch
       if (this.configurations.length > 0 && !search && this.configurations === this.parentConfigurations) {
           return;
       }
       
       if (!this.quiz || !this.quiz.created_by && !this.quiz.instructor_id) return;
       
       this.loadingConfig = true;
       try {
         const response = await quizConfigurationService.getAllConfigurations("", search, false, 1, 100);
         if (response && response.data && response.data.docs) {
            this.configurations = response.data.docs;
            this.apiLoadedConfig = true;
            this.resolveConfigurationDefaults();
         }
       } catch (error) {
         console.error(error);
       } finally {
         this.loadingConfig = false;
       }
    },
    //                    this.question.configurations.push(dc);
    //                }
    //             });
    //             // Save populated defaults
    //             this.$parent.updateLocalStorage();
    //         }
    //      }
    //    } catch (error) {
    //      console.error(error);
    //    } finally {
    //      this.loadingConfig = false;
    //    }
    // },

    debouncedFetchConfigurations: _.debounce(function (e) {
        this.fetchConfigurations(this.configSearch);
    }, 500),

    onConfigClick() {
        // Close other dropdowns
        this.showTopicDropdown = false;
        this.showSubtopicDropdown = false;
        
        this.showConfigDropdown = !this.showConfigDropdown;
        if (this.showConfigDropdown && (!this.configurations || this.configurations.length === 0)) {
            this.fetchConfigurations(this.configSearch);
        }
    },
    
    toggleConfiguration(config) {
    if (!this.question.configurations) {
        this.$set(this.question, 'configurations', []);
    }
    const index = this.question.configurations.findIndex(c => c._id === config._id);
    if (index === -1) {
        this.question.configurations.push(config);
    } else {
        this.question.configurations.splice(index, 1);
    }
    // Mark as user-edited so defaults won't be re-merged on page change
    if (this.question._userEditedFields) this.question._userEditedFields.configurations = true;
    this.$parent.updateLocalStorage();
    
    // ✅ Pass all selected configuration IDs as array
    const configIds = this.question.configurations.map(c => c._id);
    this.fetchTopics("", configIds);
  },
     
    isConfigSelected(config) {
        return this.question.configurations && this.question.configurations.some(c => (c._id || c) === config._id);
    },
    
    removeConfiguration(index) {
    this.question.configurations.splice(index, 1);
    // Mark as user-edited so defaults won't be re-merged on page change
    if (this.question._userEditedFields) this.question._userEditedFields.configurations = true;
    this.$parent.updateLocalStorage();
    
    // ✅ Fetch topics for remaining configurations
    if (this.question.configurations && this.question.configurations.length > 0) {
        const configIds = this.question.configurations.map(c => c._id);
        this.fetchTopics("", configIds);
    } else {
        // ✅ If no configurations left, clear topics
        this.availableTopics = [];
        if (!this.question.topics) {
            this.$set(this.question, 'topics', []);
        }
        this.question.topics = [];
        this.$parent.updateLocalStorage();
    }
    },
    
    hideConfigDropdown() {
        this.showConfigDropdown = false;
    },

    // Topic Methods
    resolveTopicDefaults() {
          if (!this.availableTopics || !this.availableTopics.length) return;

          // For CSV uploads: the server already sends correct per-question topics as full objects.
          // Do NOT filter them against availableTopics (quiz-level pool) because
          // per-question topics may belong to different configurations than the quiz-level ones.

          // 1. Merge quiz default topics — SKIP for CSV uploads
          //    SKIP if user has manually edited topics for this question
          //    SKIP if question has pending topic IDs to resolve (means it has its own topics)
          if (!this.isCSVUpload
              && !(this.question._userEditedFields && this.question._userEditedFields.topics)
              && (!this.topicIdsToResolve || this.topicIdsToResolve.length === 0)
              && (!this.question.topics || this.question.topics.length === 0)) {
              let defaultTopicIds = [];
              if (this.quiz && this.quiz.topic_id) {
                   if (Array.isArray(this.quiz.topic_id)) {
                      defaultTopicIds = this.quiz.topic_id;
                  } else {
                      defaultTopicIds = [this.quiz.topic_id];
                  }
                  defaultTopicIds = defaultTopicIds.map(t => (t && typeof t === 'object') ? (t._id || t) : t);
              }
              
              if (defaultTopicIds.length > 0) {
                  if (!this.question.topics) {
                      this.$set(this.question, 'topics', []);
                  }
                  const defaultTopics = this.availableTopics.filter(t => defaultTopicIds.includes(t._id));
                  defaultTopics.forEach(dt => {
                     if (!this.question.topics.some(qt => qt._id === dt._id)) {
                         this.question.topics.push(dt);
                     }
                  });
                  this.$parent.updateLocalStorage();
              }
          }

          // 2. Resolve pending topic IDs (per-question CSV IDs or edit-mode IDs)
          if (this.topicIdsToResolve && this.topicIdsToResolve.length > 0) {
            if (!this.question.topics || !Array.isArray(this.question.topics)) {
                this.$set(this.question, 'topics', []);
            }
            const resolvedTopics = this.topicIdsToResolve
              .map(id => this.availableTopics.find(t => t._id === id))
              .filter(t => t !== undefined);
            
            if (resolvedTopics.length > 0) {
               resolvedTopics.forEach(rt => {
                   if (!this.question.topics.some(qt => qt._id === rt._id)) {
                       this.question.topics.push(rt);
                   }
               });
              this.topicIdsToResolve = [];
              this.$parent.updateLocalStorage();
              this.$forceUpdate();
            } else {
              console.warn('[WARN] Could not resolve any topics from IDs');
            }
          }
    },

    async fetchTopics(search = "", configId = "") {
      console.log("🚀 ~ configId:", configId)
      // If we have topics from props and no search, don't fetch unless needed
      // Logic: If configId is provided, we must ensure our topics are for that config.
      // But parent fetches all topics or topics for default config.
      // If `configId` is passed, it means we are fetching specficially for a config. 
      // If `configId` is empty/default, we use parent provided list.
      
      if (!search && !configId && this.availableTopics.length > 0 && this.availableTopics === this.parentTopics) {
           return;
      }

      if (!this.quiz || !this.quiz.instructor_id) return;

      let configIdArray = [];
    if (configId) {
        if (Array.isArray(configId)) {
            configIdArray = configId;
        } else {
            configIdArray = [configId];
        }
    }
      
      this.loadingTopics = true;
      try {
        const response = await courseTopicService.getAllTopics(configIdArray, search, "", 1, 100);
        if (response && response.data && response.data.docs) {
          this.availableTopics = response.data.docs;
          this.resolveTopicDefaults();
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.loadingTopics = false;
      }
    },

    debouncedFetchTopics: _.debounce(function (e) {
      this.fetchTopics(this.topicSearch);
    }, 500),

    toggleTopicDropdown() {
      // Close other dropdowns
      this.showConfigDropdown = false;
      this.showSubtopicDropdown = false;

      this.showTopicDropdown = !this.showTopicDropdown;
      if (this.showTopicDropdown && (!this.availableTopics || this.availableTopics.length === 0)) {
          this.fetchTopics(this.topicSearch);
      }
    },

    hideTopicDropdown() {
      this.showTopicDropdown = false;
    },

    toggleTopicSelection(topic) {
      if (!this.question.topics) {
        this.$set(this.question, 'topics', []);
      }

      const index = this.question.topics.findIndex(t => t._id === topic._id);
      if (index === -1) {
        this.question.topics.push(topic);
      } else {
        this.question.topics.splice(index, 1);
      }
      // Mark as user-edited so defaults won't be re-merged on page change
      if (this.question._userEditedFields) this.question._userEditedFields.topics = true;
      this.$parent.updateLocalStorage();
      this.fetchSubTopics(); // Refetch subtopics when topics change
      this.$forceUpdate();
    },

    isTopicSelected(topic) {
      const inQuestion = this.question.topics && this.question.topics.some(t => t._id === topic._id);
      
      let quizTopicIds = [];
      if (Array.isArray(this.quiz.topic_id)) {
          quizTopicIds = this.quiz.topic_id;
      } else if (this.quiz.topic_id) {
          quizTopicIds = [this.quiz.topic_id];
      }
      const inQuiz = quizTopicIds.some(id => id === topic._id);

      return inQuestion || inQuiz;
    },

    removeTopic(index) {
      // The index corresponds to the selectedTopics computed array
      // We need to get the topic object first
      const topicToRemove = this.selectedTopics[index];
      if (!topicToRemove) return;

      // Check if it's in question.topics
      if (this.question.topics) {
         const qIndex = this.question.topics.findIndex(t => t._id === topicToRemove._id);
         if (qIndex !== -1) {
             this.question.topics.splice(qIndex, 1);
             // Mark as user-edited so defaults won't be re-merged on page change
             if (this.question._userEditedFields) this.question._userEditedFields.topics = true;
             this.$parent.updateLocalStorage();
             this.fetchSubTopics();
             this.$forceUpdate();
             return;
         }
      }
      
      // If we are here, it means it's likely a default quiz topic.
      // We probably shouldn't remove it, or warn user.
      // For now, doing nothing effectively prevents removal of defaults.
    },

    // Subtopic Methods
    resolveSubtopicDefaults() {
        if (!this.subtopics || !this.subtopics.length) return;

        // For CSV uploads: the server already sends correct per-question subtopics as full objects.
        // Do NOT filter them against this.subtopics (quiz-level pool) because
        // per-question subtopics may belong to different topics/configurations.
        
          // 1. Merge quiz default subtopics — SKIP for CSV uploads
          //    SKIP if user has manually edited subtopics for this question
          //    SKIP if question has pending subtopic IDs to resolve (means it has its own subtopics)
          if (!this.isCSVUpload
              && !(this.question._userEditedFields && this.question._userEditedFields.subtopics)
              && (!this.subtopicIdsToResolve || this.subtopicIdsToResolve.length === 0)
              && (!this.question.subtopics || this.question.subtopics.length === 0)) {
              let defaultSubTopicIds = [];
              if (this.quiz && this.quiz.sub_topic_id) {
                 if (Array.isArray(this.quiz.sub_topic_id)) {
                     defaultSubTopicIds = this.quiz.sub_topic_id;
                 } else {
                     defaultSubTopicIds = [this.quiz.sub_topic_id];
                 }
                defaultSubTopicIds = defaultSubTopicIds.map(st => (st && typeof st === 'object') ? (st._id || st) : st);
              }

              if (defaultSubTopicIds.length > 0) {
                  if (!this.question.subtopics || this.question.subtopics.length === 0) {
                      if (!this.question.subtopics) {
                          this.$set(this.question, 'subtopics', []);
                      }
                      const defaultSubTopics = this.subtopics.filter(st => defaultSubTopicIds.includes(st._id));
                      defaultSubTopics.forEach(dst => {
                         if (!this.question.subtopics.some(qst => qst._id === dst._id)) {
                             this.question.subtopics.push(dst);
                         }
                      });
                      this.$parent.updateLocalStorage();
                  }
              }
          }

          // 2. For CSV uploads: resolve raw sub_topics string by name-matching
          //    Then DERIVE which topics and configurations belong to this question
          //    from the resolved subtopics' parent references (topic_id, configuration_id).
          //    This is necessary because the server overwrites topics/configs with all quiz-level values.
          if (this.isCSVUpload && this.question.sub_topics && typeof this.question.sub_topics === 'string') {
              const csvSubTopicSegments = this.question.sub_topics
                  .split('|').map(s => s.trim()).filter(s => s.length > 0);
              if (csvSubTopicSegments.length > 0) {
                  // Normalize for comparison: handle curly quotes, dashes, etc.
                  const normalize = (str) => {
                      return str.trim().toLowerCase()
                          // Curly/smart quotes → straight
                          .replace(/[\u2018\u2019\u201A\u201B]/g, "'")
                          .replace(/[\u201C\u201D\u201E\u201F]/g, '"')
                          // Em/en dashes → hyphen
                          .replace(/[\u2013\u2014]/g, '-')
                          // Non-breaking spaces → regular space
                          .replace(/\u00A0/g, ' ')
                          // Collapse multiple spaces
                          .replace(/\s+/g, ' ');
                  };

                  const csvNormalized = csvSubTopicSegments.map(s => normalize(s));

                  // First try the quiz-level subtopics pool
                  let resolved = this.subtopics.filter(st =>
                      csvNormalized.includes(normalize(st.name))
                  );
                  // Fallback: also check question's own server-provided subtopics
                  if (resolved.length < csvSubTopicSegments.length && this.question.subtopics && this.question.subtopics.length > 0) {
                      const resolvedIds = new Set(resolved.map(r => r._id));
                      const serverMatches = this.question.subtopics.filter(st =>
                          st && st.name && csvNormalized.includes(normalize(st.name)) && !resolvedIds.has(st._id)
                      );
                      resolved = [...resolved, ...serverMatches];
                  }

                  if (resolved.length > 0) {
                      this.$set(this.question, 'subtopics', [...resolved]);

                      // Derive parent topics from resolved subtopics
                      const parentTopicIds = [...new Set(resolved.map(st => st.topic_id).filter(Boolean))];
                      if (parentTopicIds.length > 0) {
                          // First try availableTopics (quiz-level pool)
                          let derivedTopics = (this.availableTopics || []).filter(t => parentTopicIds.includes(t._id));
                          // Fallback: use the question's own server-provided topics (per-question CSV data)
                          if (derivedTopics.length === 0 && this.question.topics && this.question.topics.length > 0) {
                              derivedTopics = this.question.topics.filter(t => t && parentTopicIds.includes(t._id));
                          }
                          if (derivedTopics.length > 0) {
                              this.$set(this.question, 'topics', [...derivedTopics]);
                          }
                      }

                      // Derive parent configurations from derived topics
                      if (this.question.topics && this.question.topics.length > 0) {
                          const parentConfigIds = [...new Set(this.question.topics.map(t => t.configuration_id).filter(Boolean))];
                          if (parentConfigIds.length > 0 && this.configurations && this.configurations.length > 0) {
                              const derivedConfigs = this.configurations.filter(c => parentConfigIds.includes(c._id));
                              if (derivedConfigs.length > 0) {
                                  this.$set(this.question, 'configurations', [...derivedConfigs]);
                              }
                          }
                      }

                      this.$parent.updateLocalStorage();
                  }
              }
          }

          // 3. Resolve pending subtopic IDs (per-question or edit-mode)
          if (this.subtopicIdsToResolve && this.subtopicIdsToResolve.length > 0) {
            const resolvedSubtopics = this.subtopicIdsToResolve
              .map(id => this.subtopics.find(st => st._id === id))
              .filter(st => st !== undefined);
            
            if (resolvedSubtopics.length > 0) {
              if (!this.question.subtopics) {
                   this.$set(this.question, 'subtopics', []);
              }
              resolvedSubtopics.forEach(rst => {
                  if (!this.question.subtopics.some(qst => qst._id === rst._id)) {
                      this.question.subtopics.push(rst);
                  }
              });
              this.subtopicIdsToResolve = [];
              this.$forceUpdate();
            }
          }

          // 4. Enrich existing question.subtopics with learning_outcomes from fetched data
          if (this.question.subtopics && this.question.subtopics.length > 0) {
            this.question.subtopics = this.question.subtopics.map(qs => {
              const fullSubtopic = this.subtopics.find(s => s._id === qs._id);
              if (fullSubtopic) {
                return { ...qs, learning_outcomes: fullSubtopic.learning_outcomes || [] };
              }
              return qs;
            });
            this.fetchLearningOutcomes();

            // 5. For CSV uploads: resolve learning outcomes from saved raw CSV string
            if (this.isCSVUpload && this.question._csv_learning_outcomes) {
                const rawLO = this.question._csv_learning_outcomes;
                const normalize = (str) => str.trim().toLowerCase()
                    .replace(/[\u2018\u2019\u201A\u201B]/g, "'")
                    .replace(/[\u201C\u201D\u201E\u201F]/g, '"')
                    .replace(/[\u2013\u2014]/g, '-')
                    .replace(/\u00A0/g, ' ')
                    .replace(/\s+/g, ' ');
                const csvLONames = rawLO.split('|').map(s => normalize(s)).filter(s => s.length > 0);
                // Match against all available LOs from enriched subtopics (normalized)
                const matchedLOs = this.availableLearningOutcomes.filter(lo =>
                    csvLONames.includes(normalize(lo))
                );
                if (matchedLOs.length > 0) {
                    this.$set(this.question, 'learning_outcomes', [...matchedLOs]);
                    this.$parent.updateLocalStorage();
                }
                // Clear the temporary field
                delete this.question._csv_learning_outcomes;
            }
          }
    },

    async fetchSubTopics(search = "") {
      // Logic: if no search and we match parent data, skip.
      // but fetchSubTopics uses topicIds to fetch. 
      // If we rely on parentSubtopics, that pool is for default topics.
      // If user selected NEW topics in this question, we MUST fetch specific subtopics.
      
      let topicIds = [];
      if (this.question.topics && this.question.topics.length > 0) {
        topicIds = this.question.topics.map(t => t._id);
      } else if (this.topicIdsToResolve && this.topicIdsToResolve.length > 0) {
        topicIds = this.topicIdsToResolve;
      } else if (this.quiz && this.quiz.topic_id) {
        if (Array.isArray(this.quiz.topic_id)) {
            topicIds = this.quiz.topic_id.map(t => (t && typeof t==='object') ? t._id : t);
        } else {
            const t = this.quiz.topic_id;
            topicIds = [(t && typeof t==='object') ? t._id : t];
        }
      }
      
      if (topicIds.length === 0) {
          this.subtopics = [];
          return;
      }
      
      // Optimization: Check if parentSubtopics covers our needs? 
      if (!search && this.subtopics.length > 0 && this.subtopics === this.parentSubtopics) {
           let defaultTopicIds = [];
           if (this.quiz && this.quiz.topic_id) {
               if (Array.isArray(this.quiz.topic_id)) {
                  defaultTopicIds = this.quiz.topic_id.map(t => (t && typeof t==='object') ? t._id : t);
               } else {
                   const t = this.quiz.topic_id;
                   defaultTopicIds = [(t && typeof t==='object') ? t._id : t];
               }
           }
           
           // Current topic IDs
           let currentTopicIds = topicIds; 
           
           // Sort and compare strings for equality check
           const defaults = [...defaultTopicIds].sort().join(',');
           const currents = [...currentTopicIds].sort().join(',');
           
           if (defaults === currents) return;
      }

      this.loadingSubtopics = true;
      try {
        const response = await courseSubTopicService.getAllSubTopics(topicIds, search);
        if (response && response.data && response.data.docs) {
          this.subtopics = response.data.docs;
          this.resolveSubtopicDefaults();
        }
      } catch (error) {
        console.error('Error fetching subtopics:', error);
        this.$toast.error('Failed to load subtopics');
      } finally {
        this.loadingSubtopics = false;
      }
    },

    debouncedFetchSubTopics: _.debounce(function (e) {
      this.fetchSubTopics(this.subtopicSearch);
    }, 500),

    toggleSubtopicDropdown() {
      // Close other dropdowns
      this.showConfigDropdown = false;
      this.showTopicDropdown = false;

      this.showSubtopicDropdown = !this.showSubtopicDropdown;
    },
    
    hideSubtopicDropdown() {
      this.showSubtopicDropdown = false;
    },

    toggleSubtopicSelection(subtopic) {
      if (!this.question.subtopics) {
        this.$set(this.question, 'subtopics', []);
      }
      
      const index = this.question.subtopics.findIndex(s => s._id === subtopic._id);
      if (index === -1) {
        this.question.subtopics.push(subtopic);
      } else {
        this.question.subtopics.splice(index, 1);
      }
      // Mark as user-edited so defaults won't be re-merged on page change
      if (this.question._userEditedFields) this.question._userEditedFields.subtopics = true;
      this.$parent.updateLocalStorage();
      this.$forceUpdate();
    },
    
    isSubtopicSelected(subtopic) {
        return this.question.subtopics && this.question.subtopics.some(s => s._id === subtopic._id);
    },
    
    removeSubtopic(index) {
        this.question.subtopics.splice(index, 1);
        // Mark as user-edited so defaults won't be re-merged on page change
        if (this.question._userEditedFields) this.question._userEditedFields.subtopics = true;
        this.$parent.updateLocalStorage();
        this.fetchLearningOutcomes(); // Refresh LOs when subtopic removed
        this.$forceUpdate();
    },

    // Learning Outcomes Methods
    fetchLearningOutcomes() {
        // Aggregate learning outcomes from all selected subtopics
        this.loadingLearningOutcomes = true;
        this.availableLearningOutcomes = [];
        
        if (this.question.subtopics && this.question.subtopics.length > 0) {
            this.question.subtopics.forEach(subtopic => {
                if (subtopic.learning_outcomes && subtopic.learning_outcomes.length > 0) {
                    subtopic.learning_outcomes.forEach(lo => {
                        // lo is a string per backend model
                        if (!this.availableLearningOutcomes.includes(lo)) {
                            this.availableLearningOutcomes.push(lo);
                        }
                    });
                }
            });
        }
        
        this.loadingLearningOutcomes = false;
    },

    toggleLearningOutcomeDropdown() {
        this.showLearningOutcomeDropdown = !this.showLearningOutcomeDropdown;
        if (this.showLearningOutcomeDropdown) {
            this.fetchLearningOutcomes();
        }
    },

    hideLearningOutcomeDropdown() {
        this.showLearningOutcomeDropdown = false;
    },

    toggleLearningOutcomeSelection(lo) {
        if (!this.question.learning_outcomes) {
            this.$set(this.question, 'learning_outcomes', []);
        }
        
        const index = this.question.learning_outcomes.indexOf(lo);
        if (index === -1) {
            this.question.learning_outcomes.push(lo);
        } else {
            this.question.learning_outcomes.splice(index, 1);
        }
        this.$parent.updateLocalStorage();
        this.$forceUpdate();
    },

    isLearningOutcomeSelected(lo) {
        return this.question.learning_outcomes && this.question.learning_outcomes.includes(lo);
    },

    removeLearningOutcome(index) {
        this.question.learning_outcomes.splice(index, 1);
        this.$parent.updateLocalStorage();
        this.$forceUpdate();
    },

    // Equation Helper Methods for Learning Outcomes
    parseLearningOutcome(loName) {
        // Parse learning outcome to extract text and equation parts using brace counting
        // This allows handling nested braces in LaTeX correctly, e.g. \frac{a}{b}
        const parts = [];
        let currentIndex = 0;
        
        while (currentIndex < loName.length) {
            const openIndex = loName.indexOf('{{', currentIndex);
            
            if (openIndex === -1) {
                // No more equations, add rest as text
                parts.push({ type: 'text', content: loName.substring(currentIndex) });
                break;
            }
            
            // Add text before the equation
            if (openIndex > currentIndex) {
                parts.push({ type: 'text', content: loName.substring(currentIndex, openIndex) });
            }
            
            // Find matching closing }}
            let depth = 0;
            let closeIndex = -1;
            const contentStart = openIndex + 2;
            
            for (let i = contentStart; i < loName.length; i++) {
                const char = loName[i];
                
                if (char === '{') {
                    depth++;
                } else if (char === '}') {
                    if (depth === 0) {
                        // Check if this is the start of }}
                        if (loName[i+1] === '}') {
                            closeIndex = i;
                            break;
                        }
                    } else {
                        depth--;
                    }
                }
            }
            
            if (closeIndex !== -1) {
                const equationContent = loName.substring(contentStart, closeIndex);
                parts.push({ type: 'equation', content: equationContent });
                currentIndex = closeIndex + 2;
            } else {
                // No closing braces found, treat rest as text
                parts.push({ type: 'text', content: loName.substring(openIndex) });
                break;
            }
        }
         
        // Filter out empty text parts if any
        return parts.filter(p => !(p.type === 'text' && !p.content));
    },

    hasEquation(loName) {
        return loName && loName.includes('{{') && loName.includes('}}');
    },

    initStaticMathDisplay(elementId, latex) {
        this.$nextTick(() => {
            setTimeout(() => {
                const el = document.getElementById(elementId);
                if (!el || el.dataset.mqInitialized) return;
                
                try {
                    const MQ = MathQuill.getInterface(2);
                    // Clear the element first
                    el.innerHTML = '';
                    // Create StaticMath and set latex
                    const staticMath = MQ.StaticMath(el);
                    // Process the latex (handle spaces like mathCreator does)
                    let processedLatex = latex;
                    if (!processedLatex.match(/\\\s/g)) {
                        processedLatex = processedLatex.replace(/\s+/g, '\\ ');
                    }
                    staticMath.latex(processedLatex);
                    el.dataset.mqInitialized = 'true';
                } catch (e) {
                    console.warn('MathQuill init failed for', elementId, e);
                    // Fallback: just show the raw latex
                    el.textContent = latex;
                }
            }, 100);
        });
        return ''; // Return empty string for template compatibility
    }
  },
};
</script>
<style src="./edit-quiz-single-question.css" scoped></style>
